/**
 * Offer Modal Button Component
 */

import { defineAsyncComponent } from 'vue';

import { type App } from '~/app';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Offer Modal Button Component');
    app.vueApp.component('offers-modal-button', defineAsyncComponent(async () => import("./OffersModalButton.vue")));
};
